import { render } from "./QuizComponent.vue?vue&type=template&id=0fc58e96&scoped=true"
import script from "./QuizComponent.vue?vue&type=script&lang=js"
export * from "./QuizComponent.vue?vue&type=script&lang=js"

import "./QuizComponent.vue?vue&type=style&index=0&id=0fc58e96&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc58e96"]])

export default __exports__